module.exports = __webpack_public_path__ + "img/member-timeline.a3c97139.png";